'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Button = function (_Component) {
  (0, _inherits3.default)(Button, _Component);

  function Button() {
    (0, _classCallCheck3.default)(this, Button);
    return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).apply(this, arguments));
  }

  (0, _createClass3.default)(Button, [{
    key: 'render',
    value: function render() {
      if (this.props.to) {
        return _react2.default.createElement(_reactRouter.Link, {
          className: this.classes,
          rel: this.props.rel,
          to: this.props.to,
          onClick: this.props.onClick
        }, this.buttonContent);
      } else if (this.props.href) {
        return _react2.default.createElement('a', {
          className: this.classes,
          rel: this.props.rel,
          href: this.props.href,
          onClick: this.props.onClick
        }, this.buttonContent);
      } else {
        return _react2.default.createElement('button', {
          className: this.classes,
          disabled: this.props.disabled,
          type: this.props.type,
          onClick: this.props.onClick
        }, this.buttonContent);
      }
    }
  }, {
    key: 'classes',
    get: function get() {
      var className = 'Button Button--' + this.props.sureStyle;

      if (this.props.className) {
        className += ' ' + this.props.className;
      }

      if (this.props.shadow) {
        className += ' Button--shadow';
      }

      if (this.props.disabled) {
        className += ' is-disabled';
      }

      return className;
    }
  }, {
    key: 'buttonContent',
    get: function get() {
      if (this.props.isInProgress) {
        return _react2.default.createElement('span', {
          className: 'Button-spinner'
        });
      } else {
        return this.props.children;
      }
    }
  }]);
  return Button;
}(_react.Component);

Button.propTypes = {
  disabled: _propTypes2.default.bool,
  href: _propTypes2.default.string,
  isInProgress: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  rel: _propTypes2.default.string,
  shadow: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  sureStyle: _propTypes2.default.oneOf(['default', 'success', 'secondary', 'destructive', 'outline', 'facebook']),
  to: _propTypes2.default.string
};
Button.defaultProps = {
  disabled: false,
  href: null,
  isInProgress: false,
  rel: null,
  shadow: false,
  style: null,
  sureStyle: 'default',
  to: null
};
exports.default = Button;